import cpt_chart_column_option from '@/components/echarts/attrs/cpt-chart-column-option'
let op = JSON.parse(JSON.stringify(cpt_chart_column_option))

const dataText = JSON.stringify([
    {
        group:'机房1',
        data:[
            {name:'1月',start:40,end:90},
            {name:'2月',start:50,end:100},
            {name:'3月',start:30,end:60},
            {name:'4月',start:90,end:120},
            {name:'5月',start:30,end:70},
            {name:'6月',start:20,end:60},
        ]
    },
    {
        group:'机房2',
        data:[
            {name:'1月',start:90,end:120},
            {name:'2月',start:30,end:70},
            {name:'3月',start:20,end:60},
            {name:'4月',start:40,end:90},
            {name:'5月',start:50,end:100},
            {name:'6月',start:30,end:60},
        ]
    }
])
op.cptDataForm.dataText = dataText
op.attribute.series.barWidth = 10
op.attribute.series.label.fontSize = 10
op.attribute.series.barType = null
op.attribute.color = op.attribute.color.slice(0,2)
op.attribute.cptTableData = [{ "name": "分组", "value": "", "namekey": "group" },
{ "name": "维度", "value": "", "namekey": "name" },
{ "name": "开始指标", "value": "", "namekey": "start" },{ "name": "结束指标", "value": "", "namekey": "end" }
]

export default op